import { createFileRoute } from '@tanstack/react-router';
import ComplianceSettings from '@/pages/settings/compliance';

export const Route = createFileRoute(
  '/(protected)/settings/compliance'
)({
  component: ComplianceSettings,
});
